import { makeStyles, Theme } from '@material-ui/core/styles'

export const BRAND = '#008C85'
export const BRAND_DARK = '#00736d'
const BORDER = '#e6e9ed'
const SURFACE = '#f6f8fa'

export const useConcessionStyles = makeStyles((theme: Theme) => ({
    paper: {
        borderRadius: 16,
        overflow: 'hidden',
        outline: 'none',
        boxShadow:
            '0 24px 48px -12px rgba(0,0,0,0.25), 0 0 0 1px rgba(0,0,0,0.04)',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2, 3),
        borderBottom: `1px solid ${BORDER}`,
        backgroundColor: '#fff',
    },
    headerIcon: {
        width: 40,
        height: 40,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,140,133,0.12)',
        color: BRAND,
        flexShrink: 0,
    },
    headerTitle: {
        fontWeight: 700,
        fontSize: '1.05rem',
        lineHeight: 1.2,
    },
    headerSubtitle: {
        fontSize: '0.8rem',
        color: theme.palette.text.secondary,
    },
    tabs: {
        minHeight: 44,
        paddingLeft: theme.spacing(1.5),
        borderBottom: `1px solid ${BORDER}`,
        backgroundColor: '#fff',
        '& .MuiTab-root': {
            minHeight: 44,
            textTransform: 'none',
            fontWeight: 600,
            minWidth: 100,
        },
    },
    body: {
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        backgroundColor: SURFACE,
        padding: theme.spacing(2.5),
    },
    section: {
        backgroundColor: '#fff',
        border: `1px solid ${BORDER}`,
        borderRadius: 12,
        padding: theme.spacing(2.5),
        marginBottom: theme.spacing(2),
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: '0.95rem',
        color: theme.palette.text.primary,
    },
    sectionHint: {
        fontSize: '0.75rem',
        color: theme.palette.text.secondary,
    },
    row: {
        display: 'flex',
        gap: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    toggleCard: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: `1px solid ${BORDER}`,
        borderRadius: 10,
        padding: theme.spacing(1.25, 1.75),
    },
    tierCard: {
        position: 'relative',
        border: `1px solid ${BORDER}`,
        borderRadius: 10,
        padding: theme.spacing(1.75),
        marginBottom: theme.spacing(1.5),
        backgroundColor: '#fcfdfe',
    },
    tierBadge: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: 'rgba(0,140,133,0.12)',
        color: BRAND,
        fontSize: '0.75rem',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2, 3),
        borderTop: `1px solid ${BORDER}`,
        backgroundColor: '#fff',
    },
    saveButton: {
        backgroundColor: BRAND,
        color: '#fff',
        textTransform: 'none',
        fontWeight: 600,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: BRAND_DARK,
            boxShadow: 'none',
        },
    },
    cancelButton: {
        textTransform: 'none',
        fontWeight: 600,
    },
    errorBox: {
        display: 'flex',
        gap: theme.spacing(1),
        backgroundColor: 'rgba(244,67,54,0.08)',
        border: '1px solid rgba(244,67,54,0.3)',
        borderRadius: 10,
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
    },
    aiDialogPaper: {
        borderRadius: 16,
        overflow: 'hidden',
    },
    aiHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2.5, 3),
        background: `linear-gradient(120deg, ${BRAND} 0%, #00a89f 100%)`,
        color: '#fff',
    },
    aiHeaderIcon: {
        width: 44,
        height: 44,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255,255,255,0.18)',
        flexShrink: 0,
    },
    aiHeaderTitle: {
        fontWeight: 700,
        fontSize: '1.1rem',
        lineHeight: 1.2,
    },
    aiHeaderSubtitle: {
        fontSize: '0.8rem',
        opacity: 0.9,
    },
    aiFieldLabel: {
        fontWeight: 700,
        fontSize: '0.8rem',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    toneChips: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    toneChip: {
        cursor: 'pointer',
        borderColor: BORDER,
        '&:hover': {
            borderColor: BRAND,
            color: BRAND,
        },
    },
    toneChipActive: {
        cursor: 'pointer',
        backgroundColor: 'rgba(0,140,133,0.12)',
        color: BRAND,
        borderColor: BRAND,
        fontWeight: 600,
        '&:hover': {
            backgroundColor: 'rgba(0,140,133,0.18)',
        },
    },
}))

export const AI_TONE_PRESETS = [
    'Warm and concise',
    'Friendly',
    'Professional',
    'Urgent',
    'Playful',
]
